export default __webpack_public_path__ + "static/media/party.6145ca19.gif";